import { ModulesConfig } from './subconfig/modulesConfig';

/**
 * Konfiguracja aplikacji
 *
 * @export
 * @class Config
 */
export class Config {
  /**
   * URL api GraphQL
   *
   * @type {string}
   * @memberof Config
   */
  public graphQLURL: string;

  /**
   * URL api medii
   *
   * @type {string}
   * @memberof Config
   */
  public mediaURL: string;

  /**
   * URL strony publiczej
   *
   * @type {string}
   * @memberof Config
   */
  public publicSiteUrl: string;

  /**
   * Konfiguracja modułów
   *
   * @type {ModulesConfig}
   * @memberof Config
   */
  public modules: ModulesConfig;

  constructor() {
    this.graphQLURL = process.env.VUE_APP_API_URL as string;
    this.mediaURL = process.env.VUE_APP_MEDIA_URL as string;
    this.publicSiteUrl = process.env.VUE_APP_PUBLIC_SITE_URL as string;
    this.modules = new ModulesConfig();
  }
}

export const config = new Config();
